import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import WarehouseInActions from "../../../../reducers/modules/warehouse/warehouse-in/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "warehouse/warehouse-in";

export default class WarehouseInMiddleware {
  static create(params) {
    return (dispatch) => {
      dispatch(WarehouseInActions.create());
      WarehouseInMiddleware.showHelperFull(dispatch, params);
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(WarehouseInActions.update());
      WarehouseInMiddleware.showHelperFull(dispatch, params);
      WarehouseInMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(WarehouseInActions.process());
      WarehouseInMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(WarehouseInActions.reset());
    };
  }

  static getPrint(params) {
    return (dispatch) => {
      dispatch(WarehouseInActions.beforePrint());
      WarehouseInMiddleware.showPrint(dispatch, params);
    };
  }

  static resetList() {
    return (dispatch) => {
      dispatch(WarehouseInActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(WarehouseInActions.view());
      WarehouseInMiddleware.showOne(dispatch, params);
    };
  }

  static beforeCancel(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(WarehouseInActions.cancel());
      WarehouseInMiddleware.saveCancel(dispatch, post, search);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(WarehouseInActions.submit());
      WarehouseInMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(WarehouseInActions.submit());
      WarehouseInMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(WarehouseInActions.delete());
      WarehouseInMiddleware.delete(dispatch, params, id);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }
  static getHelperFull(params = null) {
    return (dispatch) => {
      WarehouseInMiddleware.showHelperFull(dispatch, params);
    };
  }

  static showHelperFull(dispatch, params, date) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseInMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-warehouse-in",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WarehouseInActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        WarehouseInMiddleware.alertHendler(dispatch, error);
      });
  }

  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseInMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WarehouseInActions.print(response.data.result));
        }
      })
      .catch((error) => {
        WarehouseInMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveCancel(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseInMiddleware.getToken()}`,
      },
      url: url + "/destroy/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            WarehouseInActions.process(),
            WarehouseInMiddleware.showlist(dispatch, search)
          );
          dispatch(WarehouseInActions.success());
          WarehouseInMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Cancel Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        WarehouseInMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseInMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WarehouseInActions.list(response.data.result));
        }
      })
      .catch((error) => {
        WarehouseInMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseInMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WarehouseInActions.view(response.data.result));
        }
      })
      .catch((error) => {
        WarehouseInMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseInMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            WarehouseInActions.process(),
            WarehouseInMiddleware.showlist(dispatch, params)
          );
          WarehouseInMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        WarehouseInMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${WarehouseInMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            WarehouseInActions.process(),
            WarehouseInMiddleware.showlist(dispatch, search)
          );
          dispatch(WarehouseInActions.success());
          WarehouseInMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        WarehouseInMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${WarehouseInMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            WarehouseInActions.process(),
            WarehouseInMiddleware.showlist(dispatch, search)
          );
          dispatch(WarehouseInActions.success());
          WarehouseInMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        WarehouseInMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(WarehouseInActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
